import { sections } from '../../constants'

const supportedSections = [
  sections.header,
  sections.hero,
  sections.body,
  sections.col1,
  sections.col2,
  sections.discoverIntro,
  sections.discoverButtons,
  sections.footer
]

export default supportedSections
